export default __webpack_public_path__ + "41eaad9754f8ffcb840f6b84c3fb8635.png";